import {Component, OnInit} from '@angular/core';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {InternalService} from './shared/services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {ApiService} from './shared/services/api.service';
import { ChatService } from './shared/services/chat.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  lang;
  constructor(public internalService:InternalService,
              public chatService: ChatService,
              private title: Title,
              private apiService: ApiService,
              private router: Router,
              private cookieService: CookieService,
              public translate:TranslateService) {
  }
  ngOnInit() {
    this.apiService.registerConfirm().subscribe((response: any) => {
      this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
      const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
      this.cookieService.set('fullName', response.res.name);
      if (rolesArray.length === 0) {
        this.router.navigate(['/forbidden']);
      }
    });

    if (this.cookieService.get('dir') == 'rtl' || this.cookieService.get('dir') == null || !this.cookieService.get('dir')) {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('fa-ir');
      this.cookieService.set('lang', '1');
    } else {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('en-us');
    }
    this.translate.get('Menu.AlobodoAdminPanel').subscribe(res =>{
      this.title.setTitle(res)
    })

  }


  changeLang(language) {
    this.internalService.changeLang(language, 0);
  }
}
